import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppStore } from '../stores/app-store';

/**
 * Sync language between i18next and app store
 * Ensures they stay in sync
 */
export function useLanguageSync() {
  const { i18n } = useTranslation();
  const { language, setLanguage } = useAppStore();

  useEffect(() => {
    // On mount, sync i18next to app store language
    if (language && i18n.language !== language) {
      i18n.changeLanguage(language);
    }
  }, []);

  useEffect(() => {
    // Listen for i18next language changes
    const handleLanguageChange = (lng: string) => {
      if (lng !== language) {
        setLanguage(lng as any);
      }
    };

    i18n.on('languageChanged', handleLanguageChange);

    return () => {
      i18n.off('languageChanged', handleLanguageChange);
    };
  }, [i18n, language, setLanguage]);
}
